export const API_BASE = import.meta.env.VITE_API_URL || 'https://stash-api.gwhite-36c.workers.dev';
